const Cookie = require('../cookie/Cookie');
const ExpUtils = require('./ExpUtils');

module.exports = class Experimentation { /**
   * Get client experiments from SEED cookie
   * @returns Array of client side experiments
   */
  static getDesktopClientSideExperiments = () => {
    const cookie = Cookie.get(ExpUtils.PROPS.COMMON.expCookieName);
    let parsedExpString;
    let expArray = [];
    if (cookie && decodeURIComponent(cookie).indexOf('|') > 0) {
      parsedExpString = decodeURIComponent(cookie).split('|')[1];
    }
    if (parsedExpString) {
      expArray = parsedExpString.split(',');
    }
    return expArray;
  }

  /**
   * Get server experiments from SEED cookie
   * @returns Array of client side experiments
   */
  static getDesktopServerSideExperiments = () => {
    const cookie = Cookie.get(ExpUtils.PROPS.COMMON.expCookieName);
    let parsedExpString;
    let expArray = [];
    if (cookie && decodeURIComponent(cookie).indexOf('|') > 1) {
      parsedExpString = decodeURIComponent(cookie).split('|')[2];
    }
    if (parsedExpString) {
      expArray = parsedExpString.split(',');
    }
    return expArray;
  }

  /**
    * Get all client side and serverside receipeIds from SEED Cookie
    * @returns
    */
  static getExpIds() {
    const expArray = [];
    return expArray.concat(this.getDesktopServerSideExperiments()).concat(this.getDesktopClientSideExperiments());
  }

  /**
    * Check if a receipeId is available in SEED Cookie
    * @param {} expId
    * @returns
    */
  static isRecipeSelected(expId) {
    const promise = new Promise((resolve) => {
      const expArray = this.getExpIds();
      if (
        expArray !== undefined
        && expArray.length > 0
        && expArray.indexOf(expId) > -1
      ) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
    return promise;
  }

  static getSelectedRecipesForExperiment(experimentRecipes) {
    const promise = new Promise((resolve) => {
      const selectedRecipes = [];
      const sessionRecipes = this.getExpIds();
      if (sessionRecipes && sessionRecipes.length > 0) {
        sessionRecipes.forEach((rec) => {
          if (experimentRecipes.includes(rec)) {
            selectedRecipes.push(rec);
          }
        });
      }
      resolve(selectedRecipes);
    });
    return promise;
  }
};
